import { render } from "./reset_email.vue?vue&type=template&id=4ccac81c&scoped=true"
import script from "./reset_email.vue?vue&type=script&lang=js"
export * from "./reset_email.vue?vue&type=script&lang=js"

import "./reset_email.vue?vue&type=style&index=0&id=4ccac81c&scoped=true&lang=scss"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccac81c"]])

export default __exports__